import { selectApiData, selectApiNoContent } from 'util/selector/apiSelector';

import { ApiMessage } from 'api/const';
import { WithData } from 'api/interfaces';
import { AxiosInstance } from 'axios';

import { PermissionFlagDto, PermissionFlagModel } from './dto/PermissionFlag.dto';
import {
  mapPermissionGroupDtoToModel,
  PermissionGroupDto,
  PermissionGroupModel,
} from './dto/PermissionGroup.dto';
import {
  mapPermissionTypesDtoToModel,
  PermissionTypesDto,
  PermissionTypesModel,
} from './dto/PermissionTypes.dto';

export namespace PermissionsApi {
  export type PermissionGroupPostEntry = {
    id?: string;
    name?: string;
    permissions?: string[];
  };
}

export class PermissionsApi {
  constructor(private client: AxiosInstance) {}

  get(projectId: number): Promise<PermissionTypesModel> {
    return this.client
      .get<WithData<PermissionTypesDto>>(`/api/v1/project/${projectId}/permissions`)
      .then(selectApiData)
      .then(mapPermissionTypesDtoToModel);
  }

  getPermissionGroups(projectId: number): Promise<PermissionGroupModel[]> {
    return this.client
      .get(`/api/v1/project/${projectId}/permission-groups`)
      .then(selectApiData)
      .then((entries) => entries.map(mapPermissionGroupDtoToModel));
  }

  addPermissionGroup(
    projectId: number,
    data: PermissionsApi.PermissionGroupPostEntry,
  ): Promise<PermissionGroupModel> {
    return this.client
      .post<WithData<PermissionGroupDto>>(`/api/v1/project/${projectId}/permission-groups`, data)
      .then(selectApiData)
      .then(mapPermissionGroupDtoToModel);
  }

  editPermissionGroup(
    projectId: number,
    permissionGroup: PermissionsApi.PermissionGroupPostEntry,
  ): Promise<PermissionGroupModel> {
    return this.client
      .post<
        WithData<PermissionGroupDto>
      >(`/api/v1/project/${projectId}/permission-groups/${permissionGroup.id}`, permissionGroup)
      .then(selectApiData)
      .then(mapPermissionGroupDtoToModel);
  }

  deletePermissionGroup(projectId: number, permissionGroupId: string): Promise<void> {
    return this.client
      .delete<ApiMessage.Deleted>(
        `/api/v1/project/${projectId}/permission-groups/${permissionGroupId}`,
      )
      .then(selectApiNoContent);
  }

  getFlags(): Promise<PermissionFlagModel[]> {
    return this.client
      .get<WithData<PermissionFlagDto[]>>(`/api/v1/permission-flags`)
      .then(selectApiData);
  }
}
